import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {dateToShortDate} from 'ki-common/utils/dateHelpers';
import {KiDatePicker} from 'components';
import styles from './KiCardPayments.theme.scss';

function KiCardPaymentsFilters(props) {
	const {
		displayType,
		fundingVehicle,
		fundingVehicles,
		statementDate,
		setDisplayType,
		setFundingVehicle,
		setStatementDate,
	} = props;

	return (
		<section className={styles.cardFilters}>
			<div className={styles.double}>
				<span className="form-instruction">Display Type:</span>
				<Select
					classNamePrefix="aut-select"
					value={displayType}
					isClearable={false}
					isDisabled={true}
					options={[
						{
							label: 'Data',
							value: 'data',
							type: 'data',
						},
					]}
					onChange={val => {
						setDisplayType(val);
					}}
				/>
			</div>
			<div>
				<span className="form-instruction">Statement Date</span>
				<KiDatePicker
					className={styles.filterDatePicker}
					value={statementDate}
					onChange={val => setStatementDate(dateToShortDate(val))}
				/>
			</div>
			<div className={styles.double}>
				<span className="form-instruction">Funding Vehicle</span>
				<Select
					classNamePrefix="aut-select"
					isClearable={true}
					isSearchable={true}
					options={fundingVehicles}
					value={fundingVehicle}
					getOptionLabel={option => option.name}
					getOptionValue={option => option._id}
					onChange={option => setFundingVehicle(option)}
				/>
			</div>
		</section>
	);
}

KiCardPaymentsFilters.propTypes = {
	fundingVehicles: PropTypes.array,
	displayType: PropTypes.object,
	fundingVehicle: PropTypes.object,
	statementDate: PropTypes.string,
	setDisplayType: PropTypes.func,
	setFundingVehicle: PropTypes.func,
	setStatementDate: PropTypes.func,
};

KiCardPaymentsFilters.defaultProps = {
	fundingVehicles: [],
	statementDate: dateToShortDate(new Date()),
};

export default KiCardPaymentsFilters;
